import React from 'react';
import classnames from 'classnames';
import { renderToStaticMarkup } from 'react-dom/server';

type SpinnerProps = {
  global?: boolean;
  small?: boolean;
  className?: string;
  color?: boolean;
};

const Spinner = ({
  global = false,
  small = false,
  className,
  color = false,
}: SpinnerProps) => {
  const classNames = classnames([
    'spinner-container',
    className,
    {
      'spinner-container--small': small,
      global,
    },
  ]);

  const spinnerClassNames = classnames([
    'spinner',
    'a-loading',
    {
      'a-default': !color,
      'a-primary': color,
    },
  ]);

  return (
    <div className={classNames}>
      <div className={spinnerClassNames} />
    </div>
  );
};

export const stringifiedSpinner = renderToStaticMarkup(<Spinner/>);
export default Spinner;
